import React, { useMemo } from 'react'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { useNavigate } from 'react-router-dom'
import Modal from '~/components/Modal'
import IdinLogo from '@verzekeringapp-mono/shared/src/assets/icons/IdinLogo'
import HelpQuestionToggle from '~/components/help_question_toggle'
import { getAgencyPrintout } from '@verzekeringapp-mono/shared/src/state/selectors/agency'
import { Images } from '@verzekeringapp-mono/shared/src/assets'
import { useIdin } from '@verzekeringapp-mono/shared/src/hooks/use_idin'

const Register = ({ outsideError }: { outsideError: string | null }) => {
  const [showModal, setShowModal] = React.useState(false)
  const navigate = useNavigate()
  const email = new URLSearchParams(location.search).get('email') ?? ''
  const token = new URLSearchParams(location.search).get('token') ?? ''
  const { createTransactionWithToken } = useIdin()
  const [error, setError] = React.useState<string|null>(null)

  const identifyIdinUser = async () => {
    if (
      token !== '' &&
      email !== ''
    ) {
      createTransactionWithToken(token, email).then((data) => {
        window.open(data?.idinTransaction.transactionUrl, '_self')
      }).catch((err) => {
        setError(err.message ?? 'Er is een fout opgetreden bij het starten van de iDIN transactie. Probeer het later opnieuw.')
      })
    }
  }

  const agencyPrintout = useAppSelector(getAgencyPrintout)

  const logo = useMemo(() => {
    if (agencyPrintout?.logoUrl) {
      return `${agencyPrintout.logoUrl}?${Date.now()}`
    }

    return Images.Logo
  }, [agencyPrintout])

  return (
    <>
      <img
        src={logo}
        width={180}
        height={70}
        alt={'Logo van jouw verzekeringsadviseur'}
      />

      <p className='title-medium mt-8'>Registreren</p>

      <p className='description mt-4'>{`We hebben geen accountgegevens gevonden op basis van je e-mailadres: ${email}`}</p>

      <p className='description mt-4'>
        Neem contact op met je verzekeringsadviseur om te verifiëren via welk
        e-mailadres je bij ons bekend bent.
      </p>

      <p className='description mt-4'>
        Je kan in dit geval eenvoudig identificeren via iDIN.
      </p>

      {(error || outsideError) && (
        <div className='my-4 rounded bg-status-danger-strong p-4 text-text-on-danger'>
          <span
            className='whitespace-pre-line text-text-on-danger'
            dangerouslySetInnerHTML={{ __html: error || outsideError || '' }}
          />
        </div>
      )}

      <button
        className='primary-btn w-full mt-8'
        onClick={identifyIdinUser}
      >
        <div className='flex w-full items-center justify-between text-text-on-brand'>
          <div className='flex h-[40px] w-[40px] aspect-square items-center justify-center rounded-full bg-surface-card'>
            <IdinLogo />
          </div>
          Identificeren met iDIN

          <div></div>
        </div>
      </button>

      <button
        className='secondary-btn w-full mt-4'
        onClick={() => navigate('/home')}
      >
        Terug
      </button>

      <button
        onClick={() => setShowModal(true)}
        className='description mt-4'
      >
        Wat is IDIN?
      </button>

      {showModal && (
        <Modal onClose={() => setShowModal(false)}>
          <>
            <h2 className='title mt-8 text-center'>Help</h2>

            <HelpQuestionToggle
              question={{
                text: 'Ik ben het e-mailadres vergeten waarop ik inlog. Wat moet ik doen?',
                answer:
                  'Neem contact op met je verzekeringsadviseur. Hij kan achterhalen via welk e-mailadres je geregistreerd bent.',
                id: '1'
              }}
            />

            <HelpQuestionToggle
              question={{
                text: 'Kan iedereen een account aanmaken?',
                answer:
                  'Nee. Je kunt alleen een Mijn Polissen account aanvragen als er Nh1816 Verzekeringen op je naam staan.',
                id: '2'
              }}
            />

            <HelpQuestionToggle
              question={{
                text: 'Mijn verzekeringen lopen via een ander gezinslid. Hoe kan ik deze verzekeringen zelf inzien?',
                answer:
                  'De hoofdgebruiker kan binnen de VerzekeringApp en Mijn Polissen omgeving een sub-gebruiker aanmaken. Dit doet hij/zij bij de instellingen. Sub-gebruikers kunnen middels een eigen account verzekeringen inzien en bijvoorbeeld het Verzekeringsbewijs raadplegen.',
                id: '3'
              }}
            />

            <HelpQuestionToggle
              question={{
                text: 'Ik heb een nieuw e-mailadres. Hoe kan ik dit wijzigen?',
                answer:
                  'Neem contact op met je verzekeringsadviseur. Hij kan je e-mailadres wijzigen.',
                id: '4'
              }}
            />
          </>
        </Modal>
      )}
    </>
  )
}

export default Register
